'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const StandardTileImage = renderWithRef('StandardTileImage', null, (a, o)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: o,
        classNames: [
            'swan-standard-tile-image'
        ],
        props: a,
        children: a.children
    }));

export { StandardTileImage };
